<template>
	<div class="foot">
		<!-- <div class="footLeft">
     <img style="width:auto"  src="../assets/image/logo2.png" alt="">
   </div>
    <href="https://play.google.com/store/apps/details?id=credit.prestamos.personale.cash.deposito.inmediato" -->
		<!-- <a  target="_blank" class="playBtn"><img src="@/assets/image/xz_ico.png" alt=""></a> -->
		<!-- -->
		<div class="column">
			<div class="content">Enlace Rápido</div>
			<a href="/about">
				<div>Sobre Nosotros</div>
			</a>
			<a href="/help">
				<div>Preguntas Frecuentes</div>
			</a>
		</div>
		<div class="column">
			<div class="content">Sobre LuckyPlata</div>
			<a href="/notice">
				<div>AVISO DE PRIVACIDAD</div>
			</a>
			<a target="blank" href="https://www.LuckyPlata.co/h5/loan.html"> <div>TÉRMINOS Y CONDICIONES DE PRÉSTAMO</div></a>
			<a target="blank" href="https://www.LuckyPlata.co/h5/use.html">
				<div>TÉRMINOS Y CONDICIONES DEL USUARIO</div>
			</a>
		</div>
		<div class="column columnImg">
			<div class="content">Síguenos</div>
			<div class="columnFlex">
				<a target="blank" href="https://www.facebook.com/LuckyPlataCo/">
					<img src="../assets/image/facebook.png" alt="" />
				</a>
				<a target="blank" href="https://www.instagram.com/luckyplata_co/">
					<img src="../assets/image/Instagram_logo.png" alt="" />
				</a>
				<a target="blank" href="https://www.tiktok.com/@luckyplata_co">
					<img src="../assets/image/siguenos_three.png" alt="" />
				</a>
			</div>
		</div>
		<div class="column columnImgLast">
			<div class="content">Descargar</div>
			<a
				target="blank"
				href="https://play.google.com/store/apps/details?id=credit.cash.prestamo.profin.loan.efectivo.luckyplata&gl=CO&hl=es-CO&pli=1"
			>
				<img src="../assets/image/playBtn.png" alt="" />
			</a>
		</div>
	</div>
</template>

<script>
	import './scss/foot.scss'
	export default {
		name: 'footPage',
		data() {
			return {}
		},
	}
</script>
